import { Component } from '@angular/core';

@Component({
	selector: 'mb-model-allocation-chartskeleton',
	templateUrl: './model-allocation-chart-skeleton.component.html',
	styleUrls: ['./model-allocation-chart-skeleton.component.scss']
})
export class ModelAllocationChartSkeletonComponent {

}
